import Cookies from 'js-cookie';

export const getCookie = (key) => {
  const result = Cookies.get(key);

  try {
    return JSON.parse(result);
  } catch {
    return undefined;
  }
};

export const setCookie = (key, value) => {
  const stringifiedValue = JSON.stringify(value);

  Cookies.set(key, stringifiedValue);
};